<template>
  <div class="history">
    <div class="history-con">
      <div class="history-msg">历史数据已全部同步到云平台</div>
      <el-table :data="tableData" stripe border height="5.8rem">
        <el-table-column prop="id" label="序号" width="100%"> </el-table-column>
        <el-table-column
          prop="time"
          label="开始时间"
          :formatter="formatterTime"
        ></el-table-column>
        <el-table-column
          prop="time"
          label="结束时间"
          :formatter="formatterETime"
        >
        </el-table-column>

        <el-table-column label="操作" width="180%">
          <template #default="scope">
            <el-button
              type="primary"
              size="mini"
              @click="look(scope.$index, scope.row)"
              >查看结果</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="tableData.length"
        background
        layout="prev, pager, next"
        :total="pageRes.total"
        class="page"
        v-model:currentPage="page.pageNum"
        @current-change="handleCurrentChange"
        :page-size="page.pageSize"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { send } from ".././../socket/index";
import * as echarts from "echarts";
export default {
  name: "Page",
  components: {},
  data() {
    return {
      // tableHeight: document.documentElement.clientHeight * 0.75,
      tableData: [
        // {
        //   id: 1,
        //   time: 1111, //时间戳
        //   mode: 0, //模式 0手动 1自动
        //   diskId: 1, //非必填，手动模式才有
        //   seatId: 1, //非必填，手动模式才有
        // },
        // {
        //   id: 1,
        //   time: 1111, //时间戳
        //   mode: 1, //模式 0手动 1自动
        //   diskId: 1, //非必填，手动模式才有
        //   seatId: 1, //非必填，手动模式才有
        // },
      ],
      page: {
        pageNum: 1,
        pageSize: 20,
      },
      pageRes: {},
    };
  },
  beforeUnmount() {},
  methods: {
    look(index, row) {
      // console.log(row);
      this.$router.push({
        name: "SeatSelect",
        params: { historyId: row.id },
      });
    },
    formatterMode(row, column) {
      // console.log("formatterType");
      // console.log(row);
      // console.log(column);
      let option = { 0: "手动", 1: "自动" };

      return option[row.mode];
    },
    formatterTarget(row, column) {
      // console.log("formatterType");
      // console.log(row);
      // console.log(column);
      if (row.mode == 0) {
        return `${row.diskId}号转盘${row.seatId}号位置`;
      } else {
        return "全部";
      }
    },
    formatterTime(row, column) {
      return moment(row.startTime).format("YYYY-MM-DD HH:mm:ss");
    },
    formatterETime(row, column) {
      return moment(row.endTime).format("YYYY-MM-DD HH:mm:ss");
    },
    handleCurrentChange() {
      this.getList();
    },
    async getList() {
      try {
        let res = await this.$myRequest({
          url: "/getHistoryDataReq",
          method: "post",
          data: {
            page: this.page,
          },
        });
        res = res.data;
        this.pageRes = res.data.page;
        this.tableData = res.data.list;
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
